import { NgIf, NgClass } from '@angular/common';
import { Component, Input, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { DropdownModule } from 'primeng/dropdown';
import { MessageModule } from 'primeng/message';
import { TableModule } from 'primeng/table';

@Component({
    selector: 'app-lead-engineer-removed',
    imports: [TableModule, DropdownModule, FormsModule, NgIf, NgClass, MessageModule],
    templateUrl: './lead-engineer-removed.component.html',
    styleUrl: './lead-engineer-removed.component.scss'
})
export class LeadEngineerRemovedComponent {
  @Input() setData: any;
  removedData : any=[];
  removedFilterData = [];
  dropDownData: any[] = [];
  selectedDivision = '';
  loading = false;

  constructor(private router: Router) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    // This lifecycle hook is called whenever an input property changes
    if (changes['setData']) {
      if (this.setData) {
        this.processLEData();
      }
    }
  }

  processLEData(){
    this.removedData = this.setData.tblNoEngr_Removed;
    this.removedData.map((item: any) => {
      if (item.tlr_status === 'I') {
        item.status = 'Installed';
        item.cssClass = 'green'
      } else if (item.tlr_status === 'P') {
        item.status = 'Pre Installation';
        item.cssClass = 'blue'
      } else if (item.tlr_status === 'R') {
        item.status = 'Removed';
        item.cssClass = 'red'
      }
    })
  if(this.setData.Division_R) {
    this.dropDownData = this.setData.Division_R.map((item: any) => {
      return { label: item, value: item };
    });
  }
  this.selectedDivision = this.dropDownData[0]?.value;
  this.filterRemovedData();
  }




  onDivisionChange(event: any) {
    this.selectedDivision = event.value;
    this.filterRemovedData();
  }

  filterRemovedData(){
    this.removedFilterData = this.removedData.filter((item: any) => {
      return item.division_name === this.selectedDivision;
    });
  }

  details(row :any){
    this.router.navigate(['/details-section', row.tag_number]);
  }

}
